import Moment from './_Moment';

export default class EditForm_Note extends Moment {
  constructor(props, context) {
    super(props, context, 'note');
  }
}
